import { useEffect } from "react";
import DubuqueHeroSection from "./components/HeroSection";
import DubuqueStickyNav from "./components/StickyNav";
import DubuqueProcessingTimeSection from "./components/ProcessingTimeSection";
import DubuqueServicesSection from "./components/ServicesSection";
import DubuqueLocalAreaSection from "./components/LocalAreaSection";
import DubuqueTestimonialsSection from "./components/TestimonialsSection";
import DubuqueAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import DubuqueComparisonSection from "./components/ComparisonSection";
import DubuqueMistakesSection from "./components/MistakesSection";
import DubuqueHowItWorksSection from "./components/HowItWorksSection";
import DubuqueFAQSection, { faqs } from "./components/FAQSection";
import DubuqueHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import DubuqueFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function DubuquePage() {
  useEffect(() => {
    document.title = "Emergency Passport Dubuque IA — Expedited Same-Day Service | Fast Passport Center";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/dubuque/";

    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in Dubuque, IA — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Dubuque County, the Tri-State region, college students, and river cruise travelers.");
    setMeta("geo.placename", "Dubuque, Iowa");
    setMeta("geo.region", "US-IA");
    setMeta("geo.position", "42.5006;-90.6646");
    setMeta("ICBM", "42.5006, -90.6646");

    const graph = [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" },
          { "@type": "ListItem", position: 2, name: "Iowa", item: "https://fastpassportcenter.com/iowa/" },
          { "@type": "ListItem", position: 3, name: "Dubuque Passport Services", item: pageUrl },
        ],
      },
      {
        "@type": "LocalBusiness",
        name: "Fast Passport Center",
        description: "Emergency and expedited passport services for Dubuque and the Tri-State area. As fast as 24 hours.",
        url: pageUrl,
        telephone: "+1-877-253-0084",
        areaServed: { "@type": "City", name: "Dubuque", containedInPlace: { "@type": "State", name: "Iowa" } },
        priceRange: "$$$",
        openingHours: ["Mo-Fr 09:00-18:00"],
        aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" },
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data";
    document.getElementById("structured-data")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      document.getElementById("structured-data")?.remove();
      document.querySelector('link[rel="canonical"]')?.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <DubuqueHeroSection />
      <DubuqueStickyNav />
      <DubuqueProcessingTimeSection />
      <DubuqueServicesSection />
      <DubuqueLocalAreaSection />
      <DubuqueTestimonialsSection />
      <DubuqueAcceptanceFacilitiesSection />
      <DubuqueComparisonSection />
      <DubuqueMistakesSection />
      <DubuqueHowItWorksSection />
      <DubuqueFAQSection />
      <DubuqueHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/dubuque" state="IA" />
      <DubuqueFinalCTA />
    </div>
  );
}